import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';

import { LeadingTeam } from './styles';

type Props = {
    awayTeamAbbrev: string;
    homeTeamAbbrev: string;
    awayTeamScore: number;
    homeTeamScore: number;
};
const GameScore: FC<Props> = ({ homeTeamAbbrev, awayTeamAbbrev, homeTeamScore, awayTeamScore }) => {
    const leadingTeamName = awayTeamScore > homeTeamScore ? awayTeamAbbrev : homeTeamAbbrev;
    const leadingTeamScore = awayTeamScore > homeTeamScore ? awayTeamScore : homeTeamScore;
    const trailingTeamName = awayTeamScore > homeTeamScore ? homeTeamAbbrev : awayTeamAbbrev;
    const trailingTeamScore = awayTeamScore > homeTeamScore ? homeTeamScore : awayTeamScore;

    return (
        <FormattedMessage
            description="Game score at any given point, ie PHI 3, ARI 1"
            defaultMessage="<b>{leadingTeamName} {leadingTeamScore},</b> {trailingTeamName} {trailingTeamScore}"
            values={{
                b: (text) => <LeadingTeam>{text}</LeadingTeam>,
                leadingTeamName,
                leadingTeamScore,
                trailingTeamName,
                trailingTeamScore,
            }}
        />
    );
};

export default GameScore;
